import { Button, CloseButton, Dialog, Portal } from '@welbe/design-system';
import { useMemo } from 'react';

type ModalPreventEnableEmployeeProps = {
	selectedEmployees: any[];
	open: boolean;
	onClose: (open: boolean) => void;
};

export const ModalPreventEnableEmployee = ({
	selectedEmployees,
	open,
	onClose,
}: ModalPreventEnableEmployeeProps) => {
	const employees = useMemo(() => {
		return {
			amount: selectedEmployees.length,
			fusioned: selectedEmployees.filter(
				(employee: any) => employee.hasEmployeeMerged,
			).length,
		};
	}, [selectedEmployees]);

	return (
		<Dialog.Root
			role="alertdialog"
			open={open}
			onOpenChange={({ open }: { open: boolean }) => onClose(open)}
		>
			<Dialog.Trigger asChild></Dialog.Trigger>
			<Portal>
				<Dialog.Backdrop />
				<Dialog.Positioner>
					<Dialog.Content>
						<Dialog.Header p="1rem">
							<Dialog.Title>¡Expediente fusionado!</Dialog.Title>
						</Dialog.Header>
						<Dialog.Body p="1rem">
							<p>
								{employees.fusioned} de {employees.amount} empleados han sido
								desactivados por fusión de expedientes. Desmarque los perfiles
								fusionados e inténtelo de nuevo.
							</p>
						</Dialog.Body>
						<Dialog.Footer p="0 1rem 1rem 1rem">
							<Dialog.ActionTrigger asChild>
								<Button variant="solid" size="sm">
									Entendido
								</Button>
							</Dialog.ActionTrigger>
						</Dialog.Footer>
						<Dialog.CloseTrigger asChild>
							<CloseButton size="sm" />
						</Dialog.CloseTrigger>
					</Dialog.Content>
				</Dialog.Positioner>
			</Portal>
		</Dialog.Root>
	);
};
